import axios from 'axios'
import globalStore from '@/stores/global.svelte'

export const baseKeyword = {
  keyword: '',
  confirmationText: '',
  add_to_groups: [],
  auto_response: {
    active: false,
    text: '',
    target_id: null,
  },
  send_follow_ups: {
    active: false,
    text: '',
  },
  send_update_links: {
    active: false,
    text: '',
  },
}

class KeywordsStore {
  create(params) {
    console.log('create keyword', params)
    return axios.post('/keywords.json', {
      keyword: params.keyword
    })
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        globalStore.setErrors(error.response.data.errors)
        return error
      })
  }

  delete(keyword) {
    return axios.delete(`/keywords/${keyword.to_param}`)
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        globalStore.setErrors(error.response.data.errors)
        return error
      })
  }

  // Updates the current keyword on success
  async syncAddToGroups(params) {
    console.log('syncAddToGroups', params)
    let keyword_id = params.keyword_id
    let group_ids = params.group_ids

    axios.post('/add_to_groups/sync.json', {
      keyword_id,
      group_ids
    })
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        console.error('syncAddToGroups error', error)
        globalStore.setErrors(error.response.data.errors)
        return error
      })
  }

  // data = {
  //   id: Integer,
  //   params: {
  //     some_attr: 'some_value',
  //   },
  //   type: 'send_follow_ups|send_update_links|auto_response' (optional)
  // }
  //
  // If the `type` key is present, it will be updated with the response data
  // in the currentKeyword
  //
  async updateActionStep(data) {
    console.log('updateActionStep', JSON.stringify(data))
    axios.put(`/action_steps/${data.id}.json`, {
      action_step: data.params
    })
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        console.error('updateActionStep error', error)
        globalStore.setErrors(error.response.data.errors)
        return error
      })
  }

  async updateKeyword(data) {
    let kwd = { ...data.params.keyword }
    // unnecessary bandwidth
    delete kwd['add_to_groups']
    delete kwd['auto_response']

    return axios.put(`/keywords/${data.id}.json`, {
      keyword: kwd
    })
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        globalStore.setErrors(error)
        return error
      })
  }

}

const keywordsStore = new KeywordsStore()
export default keywordsStore
